import ViewTimer from 'modules/ViewTimer.js'

$(document).ready(function() {
  _.each($('.list__property-item__img--new'), (elm, index) => {
    ViewTimer.setVisibility($(elm), 'list__property-item__img--new')
  })
  _.each($('.tag--new'), (elm, index) => {
    ViewTimer.setVisibility($(elm), 'tag--new')
  })
})
